<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="my-page">
      <Title jpn="ポイント移行" />
      <div class="name_area">
        <span>アカウントを連携し、ポイントの移行が可能です。</span>
      </div>
      <div class="sites">
        <div v-for="(item) in connectedList.list" :key="item.id" class="site">
          <div class="name">{{ item.name }}</div>
          <div class="button">
            <SquareButton
              v-if="item.status == '0'"
              @handleSquareBtnClick="showLoginForm(item)"
              :text="t('未連携')"
            />
            <BlackGradationButton
              v-if="item.status == '1'"
              @handleSquareBtnClick="showChangePoint(item)"
              :text="t('ポイント移行')"
            />
          </div>
        </div>
      </div>
    </div>
    <PopupOtherSiteLogin
      v-if="isLoginForm"
      :item="otherSiteItem"
      @closePopup="closePopup"
      @loginSuccess="loginSuccess"
    ></PopupOtherSiteLogin>
    <PopupOtherSitePoint
      v-if="isChangeForm"
      :item="otherSiteItem"
      @closePopup="closePopup"
      @pointSuccess="pointSuccess"
    ></PopupOtherSitePoint>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import PopupOtherSiteLogin from '@/components/molecules/PopupOtherSiteLogin.vue';
import PopupOtherSitePoint from '@/components/molecules/PopupOtherSitePoint.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';

export default {
  mixins: [t],

  components: {
    BaseTemplate,
    Title,
    PopupOtherSiteLogin,
    PopupOtherSitePoint,
    SquareButton,
    BlackGradationButton,
  },

  data: () => ({
    isLoginForm: false,
    isChangeForm: false,
    otherSiteItem: null,
  }),

  computed: {
    ...mapGetters({
      connectedList: 'transferPoint/connectedList',
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('transferPoint/getConnectedList');
  },

  methods: {
    showLoginForm(item) {
      this.otherSiteItem = item;
      this.isLoginForm = true;
    },
    closePopup() {
      this.isLoginForm = false;
      this.isChangeForm = false;
    },
    loginSuccess() {
      this.isLoginForm = false;
      this.$store.dispatch('transferPoint/getConnectedList');
      window.alert(this.t('連携成功しました。'));
    },
    pointSuccess() {
      this.$store.dispatch('user/setCurrentUser');
      this.isChangeForm = false;
      window.alert(this.t('ポイントを移行しました。'));
    },
    showChangePoint(item) {
      this.otherSiteItem = item;
      this.isChangeForm = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.my-page{
  width: 100%;
  max-width: 600px;
  min-height: calc(100vh - 303px);
  padding-top: 30px;
  padding-bottom: 50px;
  margin: 0px auto;
  .name_area {
    text-align: center;
    font-size: 18px;
    padding: 50px 0 40px 0;
    span {
      color: $black;
      padding: 0 20px;
    }
  }
  .sites {
    .site {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 20px 10px;
      border-top: solid 1px $black;
      .name {
        font-size: 18px;
      }
      &:last-child {
        border-bottom: solid 1px $black;
      }
      .button {
        width: 150px;
      }
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .my-page{
    .name_area {
      padding: 0 0 20px 0;
    }
    .gray_area {
      padding: 30px;
      margin: 0 45px 20px 45px;
      .label {
        flex-direction: column;
        span {
          font-size: 18px;
        }
        .point_area {
          margin-left: 0;
          span {
            &:nth-child(1) {
              font-size: 30px;
            }
          }
        }
      }
    }
    .link_area {
      flex-direction: column;
      padding: 0 10px;
      .link {
        border-top: solid 1px $black;
        border-left: none;
        text-align: left;
        padding-left: 12px;
        &:hover {
          text-decoration: none;
        }
        &:active {
          text-decoration: underline;
        }
        &:last-child {
          border-right: none;
          border-bottom: solid 1px $black;
        }
      }
    }
    .button_area {
      margin-top: 20px;
    }
  }
}
</style>
